import React from 'react';

import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import useTranslation from '../../hooks/useTranslation';

const RiskyDeviceDesktop = () => {
    const translated = useTranslation();
    return (
        <InfoCard className="risky-device-info-card">
            <RichIcon type={RichIconTypes.HAAND_HEIHEI} />
            <div className="risky-device-info-card__text-wrapper">
                <InfoCard.TitleH3>{translated.updatePaymentLimits.desktopRiskyDevice.title}</InfoCard.TitleH3>
                <span>{translated.updatePaymentLimits.desktopRiskyDevice.text}</span>
                <span>{translated.updatePaymentLimits.desktopRiskyDevice.text2}</span>
            </div>
        </InfoCard>
    );
};

export default RiskyDeviceDesktop;
